import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { FormattedText } from "@faire/retailer-visitor-shared/components/FormattedText";
import { GhostBlock } from "@faire/retailer-visitor-shared/components/GhostLoading/GhostBlock";
import { TrackedLink } from "@faire/retailer-visitor-shared/components/TrackedLink/index";
import { OVERLAY_EVENT_TOKEN } from "@faire/retailer-visitor-shared/features/InsightsFeed/events";
import { InsightCardContext } from "@faire/retailer-visitor-shared/features/InsightsFeed/InsightCardContext";
import { InsightCardProduct } from "@faire/retailer-visitor-shared/features/InsightsFeed/InsightCardProduct";
import { InsightCardProductImage } from "@faire/retailer-visitor-shared/features/InsightsFeed/InsightCardProductImage";
import { MuteModal } from "@faire/retailer-visitor-shared/features/InsightsFeed/MuteModal";
import { getIsApparelRetailer } from "@faire/retailer-visitor-shared/serialized-data/getIsApparelRetailer";
import { localNum } from "@faire/web--source/common/localization";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { Avatar } from "@faire/web--source/slate/Avatar";
import { Button } from "@faire/web--source/slate/Button";
import { Opacity } from "@faire/web--source/slate/Color";
import { AnnouncementMuted } from "@faire/web--source/slate/icons/foundation/Announcement";
import { Close } from "@faire/web--source/slate/icons/foundation/Close";
import { Column, Grid, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, GrowingSpacer, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { TransparencyOverlay } from "@faire/web--source/ui/TransparencyOverlay";
import { ColorSpan } from "@faire/web--source/ui/Typography/Span";
import brandPage from "@faire/web-api--source/routes/brand/brandToken";
import range from "lodash/range";
import truncate from "lodash/truncate";
import React, { useContext } from "react";
import styled, { css } from "styled-components";
var COMPACT_GAP = 2;
var COMPACT_COLUMNS = 3;
var REGULAR_GAP = 16;
var REGULAR_COLUMNS = 4;
export var InsightCard = function(props) {
    var data = props.data, asCarouselTile = props.asCarouselTile;
    var isMobile = useViewport().isMobile;
    var _React_useState = _sliced_to_array(React.useState(false), 2), muteModalOpen = _React_useState[0], setMuteModalOpen = _React_useState[1];
    var _useContext = useContext(InsightCardContext), containerOrigin = _useContext.containerOrigin, onVisible = _useContext.onVisible, onBrandClick = _useContext.onBrandClick, onOverlayClick = _useContext.onOverlayClick, mutedBrands = _useContext.mutedBrands, onChangeMute = _useContext.onChangeMute;
    var compact = asCarouselTile || isMobile;
    var gap = compact ? COMPACT_GAP : REGULAR_GAP;
    var columns = compact ? COMPACT_COLUMNS : REGULAR_COLUMNS;
    var _data_brand_token;
    var brandToken = (_data_brand_token = data === null || data === void 0 ? void 0 : data.brand_token) !== null && _data_brand_token !== void 0 ? _data_brand_token : "";
    var onVisibleRef = useDoActionWhenVisible(function() {
        var _data_insight_token;
        return onVisible === null || onVisible === void 0 ? void 0 : onVisible((_data_insight_token = data === null || data === void 0 ? void 0 : data.insight_token) !== null && _data_insight_token !== void 0 ? _data_insight_token : "");
    });
    if (!data) {
        return /*#__PURE__*/ _jsx(GhostInsightCard, {
            gap: gap,
            columns: columns,
            asCarouselTile: asCarouselTile
        });
    }
    var _data_brand_token1;
    var isMuted = (mutedBrands !== null && mutedBrands !== void 0 ? mutedBrands : []).includes((_data_brand_token1 = data.brand_token) !== null && _data_brand_token1 !== void 0 ? _data_brand_token1 : "");
    var _data_product_count;
    var displayedProducts = ((_data_product_count = data.product_count) !== null && _data_product_count !== void 0 ? _data_product_count : 0) > columns ? columns - 1 : columns;
    var _data_product_count1;
    var extraProducts = Math.max(((_data_product_count1 = data.product_count) !== null && _data_product_count1 !== void 0 ? _data_product_count1 : 0) - displayedProducts, 0);
    var renderDescription = function() {
        return asCarouselTile ? /*#__PURE__*/ _jsx(DescriptionContainer, {
            children: /*#__PURE__*/ _jsx(Description, {
                children: data.insight_description_text
            })
        }) : /*#__PURE__*/ _jsx(Typography, {
            children: data.insight_description_text
        });
    };
    var handleMuteClick = function() {
        setMuteModalOpen(true);
    };
    var renderMuteModal = function() {
        var _data_brand_name;
        return muteModalOpen ? /*#__PURE__*/ _jsx(MuteModal, {
            brandName: (_data_brand_name = data.brand_name) !== null && _data_brand_name !== void 0 ? _data_brand_name : "",
            brandToken: brandToken,
            isMuted: isMuted,
            onClose: function() {
                return setMuteModalOpen(false);
            },
            containerOrigin: containerOrigin !== null && containerOrigin !== void 0 ? containerOrigin : "",
            onChangeMute: onChangeMute
        }) : null;
    };
    if (isMuted) {
        var _data_brand_name;
        return /*#__PURE__*/ _jsxs(MutedCard, {
            children: [
                renderMuteModal(),
                /*#__PURE__*/ _jsxs(MutedCardContent, {
                    children: [
                        /*#__PURE__*/ _jsx(AnnouncementMuted, {
                            fontSize: "24px"
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "1x"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraphSansMedium",
                            align: "center",
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "NwBKrQ",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Updates muted"
                                    }
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "1x"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            color: Core.text.subdued,
                            align: "center",
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "vQOqa4",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "You\u2019ll no longer get updates from "
                                    },
                                    {
                                        type: 8,
                                        value: "MediumFormatting",
                                        children: [
                                            {
                                                type: 1,
                                                value: "brandCompanyName"
                                            }
                                        ]
                                    },
                                    {
                                        type: 0,
                                        value: "."
                                    }
                                ],
                                values: {
                                    brandCompanyName: truncate((_data_brand_name = data.brand_name) !== null && _data_brand_name !== void 0 ? _data_brand_name : ""),
                                    MediumFormatting: MediumFormatting
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "1x"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "tertiary",
                            onClick: handleMuteClick,
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "RUV07H",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Undo"
                                    }
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
    var _data_brand_token2, _data_brand_token3;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        $asCarouselTile: asCarouselTile,
        ref: onVisibleRef,
        children: [
            renderMuteModal(),
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsxs(BrandLink, {
                        token: (_data_brand_token2 = data.brand_token) !== null && _data_brand_token2 !== void 0 ? _data_brand_token2 : "",
                        onClick: function() {
                            var _data_brand_token;
                            return onBrandClick === null || onBrandClick === void 0 ? void 0 : onBrandClick((_data_brand_token = data.brand_token) !== null && _data_brand_token !== void 0 ? _data_brand_token : "");
                        },
                        to: brandPage((_data_brand_token3 = data.brand_token) !== null && _data_brand_token3 !== void 0 ? _data_brand_token3 : ""),
                        "data-test-id": "insightTile-brand-link",
                        children: [
                            /*#__PURE__*/ _jsx(Avatar, {
                                image: data.brand_profile_image,
                                size: "smaller"
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: "1x"
                            }),
                            /*#__PURE__*/ _jsx(Row, {
                                align: "center",
                                children: /*#__PURE__*/ _jsxs(Typography, {
                                    maxLines: asCarouselTile && getIsApparelRetailer() ? 2 : undefined,
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedText, {
                                            text: data.insight_title
                                        }),
                                        " ",
                                        /*#__PURE__*/ _jsx(Graphite, {
                                            children: data.insight_time_text
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(GrowingSpacer, {
                        base: "2x"
                    }),
                    /*#__PURE__*/ _jsx(MuteButton, {
                        onClick: handleMuteClick,
                        children: /*#__PURE__*/ _jsx(Close, {
                            color: Core.icon.subdued
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(GrowingSpacer, {
                base: "2x"
            }),
            data.insight_description_text ? renderDescription() : /*#__PURE__*/ _jsx(Grid, {
                gap: gap,
                columns: columns,
                children: data.products.slice(0, columns).map(function(product, index, arr) {
                    var _data_brand_token, _data_overlay_cta_link, _data_brand_token1, _product_product_token;
                    return index === arr.length - 1 && extraProducts > 0 ? /*#__PURE__*/ _jsxs(OverlayLink, {
                        to: (_data_overlay_cta_link = data.overlay_cta_link) !== null && _data_overlay_cta_link !== void 0 ? _data_overlay_cta_link : brandPage((_data_brand_token = data.brand_token) !== null && _data_brand_token !== void 0 ? _data_brand_token : ""),
                        "data-test-id": "insightTile-overlay-link",
                        onClick: function() {
                            return onOverlayClick === null || onOverlayClick === void 0 ? void 0 : onOverlayClick(OVERLAY_EVENT_TOKEN, data.overlay_cta_link);
                        },
                        children: [
                            /*#__PURE__*/ _jsx(InsightCardProductImage, {
                                image: product.image,
                                asCarouselTile: !!asCarouselTile,
                                shouldShowVerticalImagery: !!data.should_show_vertical_imagery,
                                isCompact: compact
                            }),
                            /*#__PURE__*/ _jsx(StyledOverlay, {
                                children: extraProducts > 9 ? /*#__PURE__*/ _jsx(Typography, {
                                    variant: "subheadingSansMedium",
                                    color: Core.text.inverse,
                                    "data-test-id": "insightTile-extra-products-count",
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "1PVM32",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Shop all"
                                            }
                                        ]
                                    })
                                }) : /*#__PURE__*/ _jsx(Typography, {
                                    variant: "sectionHeaderSansMedium",
                                    color: Core.text.inverse,
                                    "data-test-id": "insightTile-extra-products-count",
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "IlbPF7",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "+"
                                            },
                                            {
                                                type: 1,
                                                value: "countNumber"
                                            }
                                        ],
                                        values: {
                                            countNumber: localNum(extraProducts)
                                        }
                                    })
                                })
                            })
                        ]
                    }, index) : /*#__PURE__*/ _jsx(InsightCardProduct, {
                        brandToken: (_data_brand_token1 = data.brand_token) !== null && _data_brand_token1 !== void 0 ? _data_brand_token1 : "",
                        product: product,
                        asCarouselTile: !!asCarouselTile,
                        shouldShowVerticalImagery: !!data.should_show_vertical_imagery,
                        isCompact: compact
                    }, (_product_product_token = product.product_token) !== null && _product_product_token !== void 0 ? _product_product_token : index);
                })
            })
        ]
    });
};
var Graphite = ColorSpan(Core.text.subdued);
var Wrapper = styled(Column).withConfig({
    componentId: "sc-4fe231a6-0"
})([
    "width:100%;",
    ""
], function(props) {
    return props.$asCarouselTile ? css([
        "padding:",
        ";border:1px solid ",
        ";"
    ], getSpacing("2x"), Core.border.muted) : css([
        "",
        "{padding:",
        ";}"
    ], responsiveMediaQueries.tabletAndBelow, getSpacing(0, "2x"));
});
var MutedCard = styled(Column).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-4fe231a6-1"
})([
    "background-color:",
    ";border:1px solid ",
    ";padding:",
    ";height:100%;"
], Core.surface.subdued, Core.border.muted, getSpacing("2x", "4x"));
var MutedCardContent = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-4fe231a6-2"
})([
    "max-width:312px;"
]);
/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/IconButton/IconButton#IconButton"
 */ var MuteButton = styled.button.withConfig({
    componentId: "sc-4fe231a6-3"
})([
    "display:flex;align-self:flex-start;&:focus-visible{outline:2px solid -webkit-focus-ring-color;}"
]);
var BrandLink = styled(TrackedLink).withConfig({
    componentId: "sc-4fe231a6-4"
})([
    "display:flex;&:focus-visible{outline:2px solid -webkit-focus-ring-color;}"
]);
var OverlayLink = styled(Link).withConfig({
    componentId: "sc-4fe231a6-5"
})([
    "position:relative;flex:1;margin:2px;&:focus-visible{outline:2px solid -webkit-focus-ring-color;}"
]);
var StyledOverlay = styled(TransparencyOverlay).withConfig({
    componentId: "sc-4fe231a6-6"
})([
    "display:flex;align-items:center;justify-content:center;background:",
    ";text-align:center;padding:0 4px;hyphens:auto;"
], Core.surface.enabled + Opacity.O_35);
// We're doing this css hack to ensure the description text is aligned with
// images on other tiles. This will create a container simulating the same
// size of the images while keeping its aspect ration, then add the text inside
var DescriptionContainer = styled.div.withConfig({
    componentId: "sc-4fe231a6-7"
})([
    "width:100%;padding-top:calc( (100% - ",
    "px) / ",
    " );position:relative;"
], (COMPACT_COLUMNS - 1) * COMPACT_GAP, COMPACT_COLUMNS);
var Description = styled(Typography).withConfig({
    componentId: "sc-4fe231a6-8"
})([
    "position:absolute;top:0;left:0;"
]);
var GhostInsightCard = function(param) {
    var gap = param.gap, columns = param.columns, asCarouselTile = param.asCarouselTile;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        "data-test-id": "insight-ghost-tile",
        $asCarouselTile: asCarouselTile,
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(GhostBlock, {
                        $width: "40px",
                        $height: "40px",
                        style: {
                            borderRadius: "100%",
                            flexShrink: 0
                        }
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    }),
                    /*#__PURE__*/ _jsxs(Column, {
                        style: {
                            flexGrow: 1
                        },
                        children: [
                            /*#__PURE__*/ _jsx(GhostBlock, {
                                $height: "14px"
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "1x"
                            }),
                            /*#__PURE__*/ _jsx(GhostBlock, {
                                $height: "14px",
                                $width: "50%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Grid, {
                gap: gap,
                columns: columns,
                children: range(columns).map(function(i) {
                    return /*#__PURE__*/ _jsx(GhostBlock, {
                        style: {
                            paddingTop: "100%"
                        }
                    }, i);
                })
            })
        ]
    });
};
